import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { ClarityService } from '@services/clarity.service';
import { MaterialSymbol } from 'material-symbols';
import { FieldViewControlService } from '../../services/field-view-control.service';

@Component({
  selector: 'app-measure-panel',
  templateUrl: './measure-panel.component.html',
  styleUrls: ['./measure-panel.component.scss'],
  imports: [MatIconModule, MatButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MeasurePanelComponent {
  readonly DISABLE_MEASURE = 'Disable Measure';
  readonly ENABLE_MEASURE = 'Enable Measure';

  private readonly fieldViewControlService = inject(FieldViewControlService);
  private readonly matIconReg = inject(MatIconRegistry);
  private readonly clarityService = inject(ClarityService);

  readonly drawIcon: MaterialSymbol = 'draw';
  readonly editOffIcon: MaterialSymbol = 'edit_off';
  readonly inkEraserIcon: MaterialSymbol = 'ink_eraser';

  readonly enableMeasureSignal = this.fieldViewControlService.enableMeasure;

  readonly measureModeSignal = computed(() =>
    this.enableMeasureSignal() ? this.DISABLE_MEASURE : this.ENABLE_MEASURE
  );

  constructor() {
    this.clarityService.initializeClarity();
    this.matIconReg.setDefaultFontSetClass('material-symbols-outlined');
  }

  drawMeasurement(enable?: boolean): void {
    this.clarityService.clarityEvent(`field-view:draw-measurement-check-${enable}`);
    const newValue = enable !== undefined ? enable : !this.enableMeasureSignal();
    this.fieldViewControlService.setEnableMeasure(newValue);
  }

  clearMeasurement(): void {
    this.clarityService.clarityEvent(`field-view:clear-measurement-btn`);
    this.fieldViewControlService.setClearMeasure(true);
  }
}
